@if (isFeatureBranch) {
  <div class="feature-branch-banner">
    <div class="content">
      <p>
        Currently on <span class="font-weight-600"> {{ currentRepo }}</span>
        feature:
        <a [href]="githubUrl" target="_blank" rel="noreferrer">{{ featureBranchName }}</a>
      </p>
    </div>
    <div class="copy">
      <button stbButtonCircle iconName="copy" label="Copy link to this environment" size="small" (click)="copyLink()">
        <i class="icon-copy"></i>
      </button>
    </div>
    <div class="close">
      <button stbButtonCircle iconName="close" label="Close" size="small" (click)="closeBanner()" aria-label="Close">
        <i class="icon-close"></i>
      </button>
    </div>
  </div>
}
